export default "/images/logo-8.png?f91493bcd4224d1ee94f102321bd9d9f";